import { MutationFunction } from "@apollo/client";
import downloadIcon from "@assets/images/download-teal.svg";
import { Button } from "@material-ui/core";
import { menuWidth, shrunkMenuWidth } from "@saleor/components/Siderbar";
import {
  ExportLogChangeMutation,
  ExportLogChangeMutationVariables
} from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

import MyTypography from "../../../components/MyTypography";
import useAppState from "../../../hooks/useAppState";

interface propsStyleType {
  expandMenu?: boolean;
  bodyPaddingRight?: number;
}

interface BottomLogProps {
  dateStr?: string;
  onDownload: MutationFunction<
    ExportLogChangeMutation,
    ExportLogChangeMutationVariables
  >;
}

const useStyles = makeStyles<propsStyleType>(
  theme => ({
    bottomBar: {
      position: "fixed",
      bottom: 0,
      background: "#FFF",
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      padding: 20,
      height: 90,
      width: props =>
        props.expandMenu
          ? `calc(100% - ${menuWidth}px - 50px - ${props.bodyPaddingRight}px)`
          : `calc(100% - ${shrunkMenuWidth}px - 50px - ${props.bodyPaddingRight}px)`,
      display: "flex",
      alignItems: "center",
      zIndex: 9
    },
    barRight: {
      marginLeft: "auto",
      display: "flex",
      // display: "none", // temporary hide for DEMO purpose
      alignItems: "center"
    },
    btnOrder: {
      marginLeft: 20
    },
    btnDownload: {
      color: theme.palette.info.main
    },
    btnText: {
      color: "white"
    },
    updateTime: {
      color: theme.palette.info.main
    },
    downloadLog: {
      display: "none"
    }
  }),
  { name: "BottomBar" }
);

const BottomBarLogChange: React.FC<BottomLogProps> = ({
  dateStr,
  onDownload
}) => {
  const [appState, _] = useAppState();
  const { expandMenu, bodyPaddingRight } = appState;
  const classes = useStyles({ expandMenu, bodyPaddingRight });
  const intl = useIntl();

  const handleDownloadFile = async () => {
    const { data } = await onDownload();
    const link = document.getElementById("download-log") as HTMLAnchorElement;
    link.href = `data:${data.exportLogChange?.contentType};base64,${data.exportLogChange?.exportedFileBase64}`;
    link.target = "_self";
    link.download = data.exportLogChange?.fileName;
    link.click();
  };
  return (
    <div className={classes.bottomBar}>
      <div>
        <MyTypography variant="caption">
          <span className={classes.updateTime}>
            {intl.formatMessage({ defaultMessage: "Generate Date-Time" })}
          </span>{" "}
          {dateStr}
        </MyTypography>
      </div>
      <div className={classes.barRight}>
        <div className={classes.btnOrder}>
          <Button
            id="downloadFile"
            variant={"outlined"}
            color={"secondary"}
            onClick={handleDownloadFile}
          >
            <SVG src={downloadIcon} />
            <MyTypography variant="body1" className={classes.btnDownload}>
              {intl.formatMessage({ defaultMessage: "Download File" })}
            </MyTypography>
          </Button>
          <a id="download-log" className={classes.downloadLog}>
            Hidden link
          </a>
        </div>
      </div>
    </div>
  );
};

export default BottomBarLogChange;
